import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import React, { useCallback, useState } from 'react'

import { InventoryPartEntry } from '../../../sdk/models/InventoryPartEntry'
import { DialogDefaultActions } from '../../SharedUI/DialogDefaultActions'
import { EditInventoryForm } from './EditInventoryForm'
const FORM_ID = 'editInventoryForm'
export const useEditInventory = () => {
  const [customProps, setCustomProps] = useState<
    | {
        existingEntry: InventoryPartEntry | undefined
      }
    | undefined
  >()
  const submitCallback = useCallback(() => {
    setCustomProps(undefined)
  }, [])

  const EditInventoryDialog = useCallback(() => {
    return (
      <>
        {customProps && (
          <Dialog open={true} fullWidth={true} maxWidth={'sm'}>
            <DialogTitle data-testid="dialogTitle">
              {customProps.existingEntry ? 'Edit' : 'New'} Inventory
            </DialogTitle>
            <DialogContent>
              <EditInventoryForm
                formId={FORM_ID}
                defaultValues={customProps.existingEntry}
                submitCallback={submitCallback}
              />
            </DialogContent>
            <DialogActions>
              <DialogDefaultActions
                cancelCallback={() => setCustomProps(undefined)}
                saveButtonProps={{
                  type: 'submit',
                  form: FORM_ID
                }}
              />
            </DialogActions>
          </Dialog>
        )}
      </>
    )
  }, [customProps, submitCallback])

  return { setCustomProps, EditInventoryDialog }
}
